import { Title } from "../TabTitle";
import { useProductData } from "@/src/hooks/useProductData";
import { UtilityBadgeType } from "@/src/types";
import { useUtilityViewedPageViewAnalytics } from "@/libs/analytics/analyticsHooks";
import { TabProps } from "../../types";
import UtilityModal from "./UtilityModal";
import ActiveBadgeTimeline from "./ActiveBadgeTimeline";
import { useTokenMetadata } from "@/src/hooks/useTokenMetadata";
import { useRouter } from "next/navigation";
import { RedemptionModal } from "./RedemptionModal";
import React from "react";

import { useHasRedemption } from "./hooks/useHasRedemption";
import {
  RedemptionBody,
  RedemptionSubhead,
} from "nvs-types/dist/types/generated/contentful";
import { useCollectionData } from "@/src/hooks/useCollectionData";
import { RedemptionModalContextProvider } from "./RedemptionModal/RedemptionModalContext";
import UtilityBadges from "./UtilityBadges";

const UtilityTab: React.FC<TabProps> = ({
  productName,
  collectionName,
  tokenId,
}) => {
  const { productData } = useProductData(productName as string);

  const { collectionData } = useCollectionData(collectionName as string);

  const { data: tokenMetadata } = useTokenMetadata(
    tokenId as string,
    collectionName as string,
    productName as string,
  );
  const { hasRedemption, redemption } = useHasRedemption(
    productData,
    tokenMetadata,
  );

  useUtilityViewedPageViewAnalytics();
  const badges = productData?.tabs?.utilityTab?.badgesCollection
    ?.items as unknown as UtilityBadgeType[];

  if (!productData || !badges) {
    return null;
  }

  return (
    <RedemptionModalContextProvider>
      <Title>Utility Badges</Title>
      <UtilityBadges badges={badges} />
      <UtilityModal badges={badges} />
      {badges && tokenMetadata && (
        <ActiveBadgeTimeline
          activeBadges={badges.filter((badge) => badge?.active)}
          ownedBy={tokenMetadata.ownedBy}
          analyticsData={{
            tokenId: (tokenId as string) || "",
            tokenName: tokenMetadata.name,
            collectionSlug: (collectionName as string) || "",
            contractAddress: (collectionData?.contractAddress as string) || "",
          }}
        />
      )}
      {tokenMetadata &&
        redemption &&
        hasRedemption &&
        collectionName &&
        tokenId && (
          <RedemptionModal
            headline={redemption.headline as string}
            asset={tokenMetadata.image}
            name={tokenMetadata.nameWithoutId}
            subHead={redemption.subhead as RedemptionSubhead}
            body={redemption.body as RedemptionBody}
            legalRedemptionLink={redemption.legalRedemptionLink as string}
            collectionSlug={collectionName as string}
            tokenId={tokenId as string}
            tokenName={tokenMetadata.name}
            ownedBy={tokenMetadata.ownedBy}
            contractAddress={collectionData?.contractAddress as string}
          />
        )}
    </RedemptionModalContextProvider>
  );
};

export default UtilityTab;
